/**
 * Test comment
 */
 const test = () => {
  console.log('top');
};

export default test;